const optionList=[{
    value: "",
    display: "No seleccionado"
  },
  {
    value: "2021",
    display: "2021"
  },
  {
    value: "2020",
    display: "2020"
  },
  {
    value: "2019",
    display: "2019"
  },
  {
    value: "2018",
    display: "2018"
  },
  {
    value: "2017",
    display: "2017"
  },
  {
    value: "2016",
    display: "2016"
  },
  {
    value: "2015",
    display: "2015"
  },
  {
    value: "2014",
    display: "2014"
  },
  {
    value: "2013",
    display: "2013"
  },
  {
    value: "2012",
    display: "2012"
  },
  {
    value: "2011",
    display: "2011"
  },
  {
    value: "2010",
    display: "2010"
  },
  {
    value: "2009",
    display: "2009"
  },
  {
    value: "2008",
    display: "2008"
  },
  {
    value: "2007",
    display: "2007"
  },
  {
    value: "2006",
    display: "2006"
  },
  {
    value: "2005",
    display: "2005"
  },
  {
    value: "2004",
    display: "2004"
  },
  {
    value: "2003",
    display: "2003"
  },
  {
    value: "2002",
    display: "2002"
  },
  {
    value: "2001",
    display: "2001"
  },
  {
    value: "2000",
    display: "2000"
  }]
  export default optionList;